export default __webpack_public_path__ + "static/media/loyalty_modal_bg.b1028105.svg";